import { render, staticRenderFns } from "./OrderRejectionGlossaryModal.vue?vue&type=template&id=faaee070&"
import script from "./OrderRejectionGlossaryModal.vue?vue&type=script&scoped=true&lang=js&"
export * from "./OrderRejectionGlossaryModal.vue?vue&type=script&scoped=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports